import { apiHelper } from './api_helper';

export const API_NGUONBIETTOI_ENDPOINT = 'nguon-biet-toi';
export const nguonBietToiApi = {
    SelectAll: () => apiHelper.get(API_NGUONBIETTOI_ENDPOINT),
    SelectByCoSo: (dm_coso_id) => apiHelper.get(`coso/${dm_coso_id}/nguon-biet-toi`),
    Insert: (data) => apiHelper.post(API_NGUONBIETTOI_ENDPOINT, data),
    Update: (data) => apiHelper.put(API_NGUONBIETTOI_ENDPOINT, data),
    Delete: (id) => apiHelper.delete(`${API_NGUONBIETTOI_ENDPOINT}/${id}`),
    Detail: (id) => apiHelper.get(`${API_NGUONBIETTOI_ENDPOINT}/${id}`)
}